import RoleProtectedRoute from '../RoleProtectedRoute';
import AdminLayout from './AdminLayout';

const ProtectedAdminLayout = () => {
  return (
    <RoleProtectedRoute requiredRole="admin">
      <AdminLayout />
    </RoleProtectedRoute>
  );
};

export default ProtectedAdminLayout;
